import { render, staticRenderFns } from "./ConfirmPassword.vue?vue&type=template&id=5c1922b7&scoped=true"
import script from "./ConfirmPassword.vue?vue&type=script&lang=ts"
export * from "./ConfirmPassword.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmPassword.vue?vue&type=style&index=0&id=5c1922b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1922b7",
  null
  
)

export default component.exports